import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import forEachSelector from 'mex_components/app/scripts/elements/forEachSelector';
import addTargetEventListener from 'mex_components/app/scripts/events/addTargetEventListener';
import addPassiveEventListener from 'mex_components/app/scripts/events/addPassiveEventListener';

let widerThanBreakpoint;

export function setupVisibility() {
  const nowWiderThanBreakpoint = (window.innerWidth >= 1044);

  if(widerThanBreakpoint !== nowWiderThanBreakpoint) {
    widerThanBreakpoint = nowWiderThanBreakpoint;
    forEachSelector('[class*="-collapsible-show-more"]', showMore => {
      const showLess = showMore.parentNode.querySelector('[class*="-show-less"]');
      const content = showMore.nextElementSibling;
      showMore.classList.toggle('hidden', widerThanBreakpoint);
      showLess && showLess.classList.add('hidden');
      content && content.classList.toggle('hidden', !widerThanBreakpoint);
    });
  }
}

addTargetEventListener('click', '[class*="-collapsible-show-more"]', function(event) {
  event.preventDefault();
  const showMore = this;
  const showLess = showMore.parentNode.querySelector('[class*="-show-less"]');
  const content = showMore.nextElementSibling;
  showMore.classList.add('hidden');
  showLess && showLess.classList.remove('hidden');
  content && content.classList.remove('hidden');
});

addTargetEventListener('click', '[class*="-collapsible-show-less"]', function(event) {
  event.preventDefault();
  const showLess = this;
  const showMore = showLess.parentNode.querySelector('[class*="-show-more"]');
  const content = showLess.previousElementSibling;
  showMore && showMore.classList.remove('hidden');
  showLess.classList.add('hidden');
  content && content.classList.add('hidden');
});

addPassiveEventListener(window, 'resize', setupVisibility);
addStartupScript(setupVisibility);
